<div class="container-fluid">
  <div class="row">
    <div style="padding: 0" class="col-md-3">
      <app-auth-side></app-auth-side>
    </div>
    <div class="col-md-9">
      <div class="login d-flex align-items-center py-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 mx-auto">
              <h2 class="mb-2">{{ keys.setup.title | translate }}</h2>
              <p class="text-muted mb-4">{{ keys.setup.lead | translate }}</p>
              <form [formGroup]="form" (ngSubmit)="submit()">
                <div class="form-group mb-3">
                  <label for="providerInvitationPassword">{{ keys.setup.passwordLabel | translate }}</label>
                  <input
                    id="providerInvitationPassword"
                    type="password"
                    formControlName="password"
                    class="form-control form-control-with-validation"
                    [ngClass]="{ 'is-invalid': submitted && form.get('password')?.errors }"
                  />
                  <div *ngIf="submitted && form.get('password')?.errors" class="invalid-feedback d-block">
                    <div *ngIf="form.get('password')?.errors?.['required']">{{ keys.setup.passwordRequired | translate }}</div>
                    <div *ngIf="form.get('password')?.errors?.['minlength']">{{ keys.setup.passwordMinLength | translate }}</div>
                  </div>
                </div>

                <div class="form-group mb-3">
                  <label for="providerInvitationConfirmPassword">{{ keys.setup.confirmPasswordLabel | translate }}</label>
                  <input
                    id="providerInvitationConfirmPassword"
                    type="password"
                    formControlName="confirmPassword"
                    class="form-control form-control-with-validation"
                    [ngClass]="{ 'is-invalid': submitted && (form.get('confirmPassword')?.errors || passwordMismatch) }"
                  />
                  <div *ngIf="submitted && form.get('confirmPassword')?.errors" class="invalid-feedback d-block">
                    <div *ngIf="form.get('confirmPassword')?.errors?.['required']">{{ keys.setup.confirmRequired | translate }}</div>
                  </div>
                  <div *ngIf="submitted && passwordMismatch" class="invalid-feedback d-block">
                    {{ keys.setup.passwordsMismatch | translate }}
                  </div>
                </div>

                <div *ngIf="errorMessage" class="alert alert-danger py-2">{{ errorMessage }}</div>

                <button type="submit" class="btn btn-primary btn-block">{{ keys.setup.activate | translate }}</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ngx-spinner color="rgba(30, 205, 100, 1)" type="ball-scale-multiple"></ngx-spinner>
